"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _productPositionSelectors = require("../../redux/selectors/productPositionSelectors");
var _WalletCardGridComponent = _interopRequireDefault(require("./WalletCardGridComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    fetching: (0, _productPositionSelectors.fetchingSelector)(state),
    products: (0, _productPositionSelectors.fundedPositionsSelector)(state),
    detailsLink: ownProps.detailsLink
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps)(_WalletCardGridComponent["default"]);